(function () {
  "use strict";

  var t = {
    210: function _(t, e, r) {
      var _n,
          s = this && this.__extends || (_n = function n(t, e) {
        return _n = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
          }
        }, _n(t, e);
      }, function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");

        function r() {
          this.constructor = t;
        }

        _n(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      }),
          i = this && this.__awaiter || function (t, e, r, n) {
        return new (r || (r = Promise))(function (s, i) {
          function o(t) {
            try {
              u(n.next(t));
            } catch (t) {
              i(t);
            }
          }

          function c(t) {
            try {
              u(n.throw(t));
            } catch (t) {
              i(t);
            }
          }

          function u(t) {
            var e;
            t.done ? s(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
              t(e);
            })).then(o, c);
          }

          u((n = n.apply(t, e || [])).next());
        });
      },
          o = this && this.__generator || function (t, e) {
        var r,
            n,
            s,
            i,
            o = {
          label: 0,
          sent: function sent() {
            if (1 & s[0]) throw s[1];
            return s[1];
          },
          trys: [],
          ops: []
        };
        return i = {
          next: c(0),
          throw: c(1),
          return: c(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;

        function c(i) {
          return function (c) {
            return function (i) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; o;) {
                try {
                  if (r = 1, n && (s = 2 & i[0] ? n.return : i[0] ? n.throw || ((s = n.return) && s.call(n), 0) : n.next) && !(s = s.call(n, i[1])).done) return s;

                  switch (n = 0, s && (i = [2 & i[0], s.value]), i[0]) {
                    case 0:
                    case 1:
                      s = i;
                      break;

                    case 4:
                      return o.label++, {
                        value: i[1],
                        done: !1
                      };

                    case 5:
                      o.label++, n = i[1], i = [0];
                      continue;

                    case 7:
                      i = o.ops.pop(), o.trys.pop();
                      continue;

                    default:
                      if (!((s = (s = o.trys).length > 0 && s[s.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                        o = 0;
                        continue;
                      }

                      if (3 === i[0] && (!s || i[1] > s[0] && i[1] < s[3])) {
                        o.label = i[1];
                        break;
                      }

                      if (6 === i[0] && o.label < s[1]) {
                        o.label = s[1], s = i;
                        break;
                      }

                      if (s && o.label < s[2]) {
                        o.label = s[2], o.ops.push(i);
                        break;
                      }

                      s[2] && o.ops.pop(), o.trys.pop();
                      continue;
                  }

                  i = e.call(t, o);
                } catch (t) {
                  i = [6, t], n = 0;
                } finally {
                  r = s = 0;
                }
              }

              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, c]);
          };
        }
      },
          c = this && this.__spreadArray || function (t, e, r) {
        if (r || 2 === arguments.length) for (var n, s = 0, i = e.length; s < i; s++) {
          !n && s in e || (n || (n = Array.prototype.slice.call(e, 0, s)), n[s] = e[s]);
        }
        return t.concat(n || Array.prototype.slice.call(e));
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var u = r(543),
          a = r(517),
          d = r(809),
          p = r(690),
          h = r(64),
          f = r(923),
          l = r(405),
          v = r(238),
          y = {
        main: f.BitcoinNetworks.bitcoin,
        test: f.BitcoinNetworks.bitcoin_testnet,
        regtest: f.BitcoinNetworks.bitcoin_regtest
      },
          b = function (t) {
        function e(e) {
          var r = this,
              n = e.uri,
              s = e.username,
              i = e.password,
              o = e.network,
              c = e.addressType,
              u = void 0 === c ? h.bitcoin.AddressType.BECH32 : c;
          r = t.call(this, {
            network: o
          }) || this;
          var a = Object.values(h.bitcoin.AddressType);
          if (!a.includes(u)) throw new Error("addressType must be one of ".concat(a.join(",")));
          return r._addressType = u, r._network = o, r._rpc = new p.JsonRpcProvider(n, s, i), r._addressInfoCache = {}, r;
        }

        return s(e, t), e.prototype.signMessage = function (t, e) {
          return i(this, void 0, void 0, function () {
            return o(this, function (r) {
              return [2, this._rpc.jsonrpc("signmessage", e, t).then(function (t) {
                return Buffer.from(t, "base64").toString("hex");
              })];
            });
          });
        }, e.prototype.withTxFee = function (t, e) {
          return i(this, void 0, void 0, function () {
            var r, n, s;
            return o(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = new h.BigNumber(e).div(1e8).times(1e3).toNumber(), [4, this._rpc.jsonrpc("getwalletinfo")];

                case 1:
                  return n = i.sent().paytxfee, [4, this._rpc.jsonrpc("settxfee", r)];

                case 2:
                  return i.sent(), [4, t()];

                case 3:
                  return s = i.sent(), [4, this._rpc.jsonrpc("settxfee", n)];

                case 4:
                  return i.sent(), [2, s];
              }
            });
          });
        }, e.prototype._sendTransaction = function (t) {
          return i(this, void 0, void 0, function () {
            var e, r, n, s;
            return o(this, function (i) {
              switch (i.label) {
                case 0:
                  return e = new h.BigNumber(t.value).dividedBy(1e8).toNumber(), [4, this._rpc.jsonrpc("sendtoaddress", t.to, e, "", "", !1, !0)];

                case 1:
                  return r = i.sent(), [4, this._rpc.jsonrpc("gettransaction", r, !0)];

                case 2:
                  return n = i.sent(), s = new h.BigNumber(n.fee).abs().times(1e8).toNumber(), [2, (0, l.normalizeTransactionObject)((0, l.decodeRawTransaction)(n.hex, this._network), s)];
              }
            });
          });
        }, e.prototype.sendTransaction = function (t) {
          return i(this, void 0, void 0, function () {
            var e = this;
            return o(this, function (r) {
              return [2, t.fee ? this.withTxFee(function () {
                return i(e, void 0, void 0, function () {
                  return o(this, function (e) {
                    return [2, this._sendTransaction(t)];
                  });
                });
              }, t.fee) : this._sendTransaction(t)];
            });
          });
        }, e.prototype.updateTransactionFee = function (t, e) {
          return i(this, void 0, void 0, function () {
            var r,
                n = this;
            return o(this, function (s) {
              return r = (0, a.isString)(t) ? t : t.hash, [2, this.withTxFee(function () {
                return i(n, void 0, void 0, function () {
                  var t, e, n;
                  return o(this, function (s) {
                    switch (s.label) {
                      case 0:
                        return [4, this._rpc.jsonrpc("bumpfee", r)];

                      case 1:
                        return t = s.sent(), [4, this._rpc.jsonrpc("gettransaction", t.txid, !0)];

                      case 2:
                        return e = s.sent(), n = new h.BigNumber(e.fee).abs().times(1e8).toNumber(), [2, (0, l.normalizeTransactionObject)((0, l.decodeRawTransaction)(e.hex, this._network), n)];
                    }
                  });
                });
              }, e)];
            });
          });
        }, e.prototype.signPSBT = function (t, e) {
          return i(this, void 0, void 0, function () {
            var r, n, s, i, c, a;
            return o(this, function (d) {
              switch (d.label) {
                case 0:
                  r = u.Psbt.fromBase64(t, {
                    network: this._network
                  }), n = function n(t) {
                    var e, n, i, c;
                    return o(this, function (o) {
                      switch (o.label) {
                        case 0:
                          return [4, s.getUsedAddresses()];

                        case 1:
                          return e = o.sent(), n = e.find(function (e) {
                            return e.derivationPath === t.derivationPath;
                          }), [4, s.dumpPrivKey(n.address)];

                        case 2:
                          return i = o.sent(), c = u.ECPair.fromWIF(i, s._network), r.signInput(t.index, c), [2];
                      }
                    });
                  }, s = this, i = 0, c = e, d.label = 1;

                case 1:
                  return i < c.length ? (a = c[i], [5, n(a)]) : [3, 4];

                case 2:
                  d.sent(), d.label = 3;

                case 3:
                  return i++, [3, 1];

                case 4:
                  return [2, r.toBase64()];
              }
            });
          });
        }, e.prototype.signBatchP2SHTransaction = function (t, e, r, n, s) {
          return void 0 === s && (s = !1), i(this, void 0, void 0, function () {
            var n, i, c, a, d, p, h, f, l, v;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  n = [], i = 0, c = e, o.label = 1;

                case 1:
                  return i < c.length ? (a = c[i], [4, this.dumpPrivKey(a)]) : [3, 4];

                case 2:
                  d = o.sent(), p = u.ECPair.fromWIF(d, this._network), n.push(p), o.label = 3;

                case 3:
                  return i++, [3, 1];

                case 4:
                  for (h = [], f = 0; f < t.length; f++) {
                    void 0, l = s ? r.hashForWitnessV0(t[f].index, t[f].outputScript, t[f].vout.vSat, u.Transaction.SIGHASH_ALL) : r.hashForSignature(t[f].index, t[f].outputScript, u.Transaction.SIGHASH_ALL), v = u.script.signature.encode(n[f].sign(l), u.Transaction.SIGHASH_ALL), h.push(v);
                  }

                  return [2, h];
              }
            });
          });
        }, e.prototype.dumpPrivKey = function (t) {
          return i(this, void 0, void 0, function () {
            return o(this, function (e) {
              return [2, this._rpc.jsonrpc("dumpprivkey", t)];
            });
          });
        }, e.prototype.getNewAddress = function (t, e) {
          return void 0 === e && (e = ""), i(this, void 0, void 0, function () {
            var r, n, s;
            return o(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = t ? [e, t] : [e], [4, (s = this._rpc).jsonrpc.apply(s, c(["getnewaddress"], r, !1))];

                case 1:
                  return (n = i.sent()) ? [2, this.getAddressInfo(n)] : [2, null];
              }
            });
          });
        }, e.prototype.getAddressInfo = function (t) {
          return i(this, void 0, void 0, function () {
            var e, r, n, s;
            return o(this, function (i) {
              switch (i.label) {
                case 0:
                  return t in this._addressInfoCache ? [2, this._addressInfoCache[t]] : [4, this._rpc.jsonrpc("getaddressinfo", t)];

                case 1:
                  return (e = i.sent()).iswatchonly || (r = e.pubkey, n = e.hdkeypath), s = new h.Address({
                    address: t,
                    publicKey: r,
                    derivationPath: n
                  }), this._addressInfoCache[t] = s, [2, s];
              }
            });
          });
        }, e.prototype.getAddresses = function () {
          return i(this, void 0, void 0, function () {
            return o(this, function (t) {
              return [2, this.getUsedAddresses()];
            });
          });
        }, e.prototype.getUnusedAddress = function () {
          return i(this, void 0, void 0, function () {
            return o(this, function (t) {
              return [2, this.getNewAddress(this._addressType)];
            });
          });
        }, e.prototype.getUsedAddresses = function () {
          return i(this, void 0, void 0, function () {
            var t,
                e,
                r,
                n = this;
            return o(this, function (s) {
              switch (s.label) {
                case 0:
                  return [4, this._rpc.jsonrpc("listaddressgroupings")];

                case 1:
                  return t = s.sent(), [4, this._rpc.jsonrpc("listreceivedbyaddress", 0, !0, !1)];

                case 2:
                  return e = s.sent(), r = (0, a.uniq)(c(c([], (0, a.flatten)(t).map(function (t) {
                    return t[0];
                  }), !0), e.map(function (t) {
                    return t.address;
                  }), !0)), [4, Promise.all(r.map(function (t) {
                    return n.getAddressInfo(t);
                  }))];

                case 3:
                  return [2, s.sent()];
              }
            });
          });
        }, e.prototype.getWalletAddress = function (t) {
          return i(this, void 0, void 0, function () {
            return o(this, function (e) {
              return [2, this.getAddressInfo(t)];
            });
          });
        }, e.prototype.isWalletAvailable = function () {
          return i(this, void 0, void 0, function () {
            return o(this, function (t) {
              switch (t.label) {
                case 0:
                  return t.trys.push([0, 2,, 3]), [4, this._rpc.jsonrpc("getwalletinfo")];

                case 1:
                  return t.sent(), [2, !0];

                case 2:
                  return t.sent(), [2, !1];

                case 3:
                  return [2];
              }
            });
          });
        }, e.prototype.getConnectedNetwork = function () {
          return i(this, void 0, void 0, function () {
            var t, e;
            return o(this, function (r) {
              switch (r.label) {
                case 0:
                  return [4, this._rpc.jsonrpc("getblockchaininfo")];

                case 1:
                  return t = r.sent(), e = t.chain, [2, y[e]];
              }
            });
          });
        }, e.prototype.generateSecret = function (t) {
          return i(this, void 0, void 0, function () {
            var e, r, n, s;
            return o(this, function (i) {
              switch (i.label) {
                case 0:
                  e = "secretAddress", i.label = 1;

                case 1:
                  return i.trys.push([1, 3,, 5]), [4, this._rpc.jsonrpc("getaddressesbylabel", e)];

                case 2:
                  return n = i.sent(), r = Object.keys(n)[0], [3, 5];

                case 3:
                  return i.sent(), [4, this.getNewAddress(h.bitcoin.AddressType.LEGACY, e)];

                case 4:
                  return r = i.sent().address, [3, 5];

                case 5:
                  return [4, this.signMessage(t, r)];

                case 6:
                  return s = i.sent(), [2, (0, v.sha256)(s)];
              }
            });
          });
        }, e;
      }(d.WalletProvider);

      e.default = b;
    },
    175: function _(t, e, r) {
      var n = this && this.__importDefault || function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.BitcoinNodeWalletProvider = void 0;
      var s = n(r(210));
      e.BitcoinNodeWalletProvider = s.default;
    },
    923: function _(t) {
      t.exports = require("@yaswap/bitcoin-networks");
    },
    405: function _(t) {
      t.exports = require("@yaswap/bitcoin-utils");
    },
    238: function _(t) {
      t.exports = require("@yaswap/crypto");
    },
    690: function _(t) {
      t.exports = require("@yaswap/jsonrpc-provider");
    },
    64: function _(t) {
      t.exports = require("@yaswap/types");
    },
    809: function _(t) {
      t.exports = require("@yaswap/wallet-provider");
    },
    543: function _(t) {
      t.exports = require("bitcoinjs-lib");
    },
    517: function _(t) {
      t.exports = require("lodash");
    }
  },
      e = {},
      r = function r(n) {
    var s = e[n];
    if (void 0 !== s) return s.exports;
    var i = e[n] = {
      exports: {}
    };
    return t[n].call(i.exports, i, i.exports, r), i.exports;
  }(175);

  module.exports = r;
})();